import { useParallax } from 'components/parallax/useParallax'
import PhoneRightSrc from './images/phone-right.png'
import PhoneRightLandscapeSrc from './images/phone-right-landscape.png'
import { PhoneRightContainer, PhoneImg } from './styled'
import { breakpoints } from 'styles/mq'

export const ParallaxPhoneRight = () => {
  const { ref, translateY } = useParallax({ fromTo: ['-30rem', '30rem'] })

  return (
    <PhoneRightContainer ref={ref} style={{ translateY }}>
      <picture>
        <source
          srcSet={PhoneRightLandscapeSrc}
          media={breakpoints.parallaxOff}
        />
        <PhoneImg src={PhoneRightSrc} alt="" aria-hidden />
      </picture>
    </PhoneRightContainer>
  )
}
